import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import './index.scss';

const ButtonPill = ({key, tabIndex = 0, className = '', children, onClick, selected = false, disabled = false}) => (
  <button
    key={key}
    className={cs('Button_pill', className, {
      'Button_pill--selected': selected,
    })}
    onClick={onClick}
    tabIndex={tabIndex}
    disabled={disabled}
    type="button"
  >
    {children}
  </button>
);

ButtonPill.propTypes = {
  tabIndex: PropTypes.number,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
  selected: PropTypes.bool,

  /**
   * Is button disabled?
   */
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  key: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

ButtonPill.contextTypes = {
  router: PropTypes.object,
};

export default ButtonPill;
